import { Routes } from '@angular/router';
import { authGuard, defaultDashboardGuard } from './core/guards';

export const routes: Routes = [
  // Public routes (login, register)
  {
    path: 'login',
    loadComponent: () =>
      import('./features/public/login/login.page').then((m) => m.LoginPage),
  },
  {
    path: 'register',
    loadComponent: () =>
      import('./features/public/register/register.page').then((m) => m.RegisterPage),
  },
  {
    path: 'register/client',
    loadComponent: () =>
      import('./features/public/register/register-client.page').then(
        (m) => m.RegisterClientPage
      ),
  },
  {
    path: 'register/cleaner',
    loadComponent: () =>
      import('./features/public/register/register-cleaner.page').then(
        (m) => m.RegisterCleanerPage
      ),
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./features/public/forgot-password/forgot-password.page').then(
        (m) => m.ForgotPasswordPage
      ),
  },
  {
    path: 'reset-password',
    loadComponent: () =>
      import('./features/public/reset-password/reset-password.page').then(
        (m) => m.ResetPasswordPage
      ),
  },
  {
    path: 'auth/callback',
    loadComponent: () =>
      import('./features/public/login/login.page').then((m) => m.LoginPage),
  },

  // Protected routes with AppShell layout
  {
    path: '',
    loadComponent: () =>
      import('./layout/app-shell/app-shell.component').then((m) => m.AppShellComponent),
    canActivate: [authGuard],
    children: [
      // Root path: redirect to role-specific dashboard (client, cleaner, admin)
      {
        path: '',
        canActivate: [defaultDashboardGuard],
        children: [],
      },
      // Client routes
      {
        path: 'client',
        loadChildren: () =>
          import('./features/client/client.routes').then((m) => m.CLIENT_ROUTES),
      },
      // Cleaner routes
      {
        path: 'cleaner',
        loadChildren: () =>
          import('./features/cleaner/cleaner.routes').then((m) => m.CLEANER_ROUTES),
      },
      // Admin routes
      {
        path: 'admin',
        loadChildren: () =>
          import('./features/admin/admin.routes').then((m) => m.ADMIN_ROUTES),
      },
      // Settings route
      {
        path: 'settings',
        loadChildren: () =>
          import('./features/settings/settings.routes').then((m) => m.SETTINGS_ROUTES),
      },
      // Notifications route (shared across roles)
      {
        path: 'notifications',
        loadComponent: () =>
          import('./features/notifications/notifications.page').then((m) => m.NotificationsPage),
      },
    ],
  },

  // Default redirect to login
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },

  // Catch-all redirect
  {
    path: '**',
    redirectTo: 'login',
  },
];
